<template>
  <fieldset class="account__form-section account__form-section--wide">
    <legend class="account__form-section-title layout--margin-bottom-xxs">
      {{ formSection }}
    </legend>
    <div 
      v-if="!defaultCard && subscription.discriminator === 'Free'" 
      class="layout--text-button-wrap">
      <p>No current credit card information available.</p>
      <router-link
        :to="{ name: 'change plan' }"
        class="button ayout--margin-bottom-sm"
        >Upgrade Plan</router-link
      >
    </div>
    <CreditCard
      v-else
      :buttonText="defaultCard ? 'Edit Card Information' : 'Add Card'"
      classes="credit-card__wrap--row"
    />
  </fieldset>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CreditCard from "../../../components/CreditCard";

const formSection = "Credit Card";

export default {
  name: "CreditCardSection",
  components: {
    CreditCard,
  },
  data() {
    return {
      formSection,
    };
  },
  computed: {
    ...mapGetters("account", ["defaultCard", "subscription" ]),
  },
};
</script>

<style></style>
